<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur de la sécurité routière' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur de la sécurité routière' | translate}}</span>
    </div>
    <div class="container justif-center my-5">
      <p><span class="bold-blue">{{ 'Le secteur de la sécurité routière' | translate}}</span> {{ 'vise à réduire les risques de blessures et de décès sur les routes.' | translate}}</p>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global motorways sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States motorways sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French motorways sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-4 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'On estime que les accidents de la route sont actuellement la huitième cause de décès dans tous les groupes d’âge.' | translate}} <a class="source" href="https://www.who.int/data/gho/data/themes/topics/topic-details/GHO/road-traffic-mortality" target="_blank" rel="noopener nofollow" title="who int">{{'(source)' | translate}}</a></li>
                      <li>{{'La part des indemnités et des absences du travail dues aux accidents et aux maladies professionnelles dans le PIB mondial est estimée à près de 4 %.' | translate}} <a class="source" href="https://bmcpublichealth.biomedcentral.com/articles/10.1186/s12889-020-10050-7" target="_blank" rel="noopener nofollow" title="bmcpublichealth biomedcentral">{{'(source)' | translate}}</a></li>
                    </ul>
                    <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                    <ul class="mb-0 mt-2 text-justify">
                      <li>{{'La taille du marché mondial de la sécurité routière devrait passer de 3,0 milliards USD en 2020 à 4,9 milliards USD en 2025.' | translate}} <a class="source" href="https://www.marketsandmarkets.com/Market-Reports/road-safety-market-93636585.html" target="_blank" rel="noopener nofollow" title="marketsandmarkets">{{'(source)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'En 2019, plus de 115 000 accidents de zones de travail, plus de 39 000 blessures et 842 décès sont survenus dans les zones de travail des patrouilleurs.' | translate}} <a class="source" href="https://www.workzonebarriers.com/work-zone-crash-facts.html" target="_blank" rel="noopener nofollow" title="workzonebarriers">{{'(source)' | translate}}</a></li>
                    <li>{{'Les blessures survenant à l’intérieur de la zone de travail sont dues au fait que les travailleurs sont heurtés par des équipements lourds, qui ont généralement de grands angles morts, et à l’exposition aux dangers typiques de tous les chantiers de construction, notamment les lignes électriques aériennes, les risques de trébuchement, les conduites de gaz et les chutes d’objets.' | translate}} <a class="source" href="https://www.hg.org/legal-articles/road-worker-accidents-and-injuries-49687" target="_blank" rel="noopener nofollow" title="hg">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'L’Amérique du Nord est la région la plus avancée en termes d’adoption de technologies et de développement d’infrastructures dans le secteur de la sécurité routière ' | translate}} <a class="source" href="https://www.prnewswire.com/news-releases/road-safety-market-worth-4-7-billion-by-2024--exclusive-report-by-marketsandmarkets-300880173.html" target="_blank" rel="noopener nofollow" title="prnewswire">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'ACCIDENTS :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'En 2019, un accident touchant le personnel autoroutier a lieu tous les trois jours. Ce nombre d’accidents a augmenté en 2019 (145 accidents en 2019 contre 132 accidents en 2018).' | translate}} <a class="source" href="https://www.personnel-autoroutes.fr/fr/les-chiffres/le-bilan-des-accidents.htm" target="_blank" rel="noopener nofollow" title="personnel-autoroutes">{{'(source)' | translate}}</a></li>
                    <li>{{'Les accidents des patrouilleurs surviennent le plus souvent lors de la mise en place du balisage des chantiers (49 % en 2019) ainsi qu’en raison de la somnolence et de l’inattention lors d’interventions urgentes pour aider des conducteurs blessés (28 % en 2019).' | translate}} <a class="source" href="https://www.autoroutes.fr/FCKeditor/UserFiles/File/bilan_securite_du_personnel_2019.pdf" target="_blank" rel="noopener nofollow" title="autoroutes">{{'(source)' | translate}}</a></li>
                  </ul>
                  <p class="mb-0 mt-4 sub-title"><i class="fas fa-check-circle mr-2 custom-circle"></i>{{'MARCHÉ :' | translate}}</p>
                  <ul class="mb-0 mt-2 text-justify">
                    <li>{{'La France bénéficie d’une amélioration importante de la sécurité routière grâce à la réduction du trafic causée par la pandémie ' | translate}} <a class="source" href="https://www.worldhighways.com/wh12/news/frances-road-safety-improvement" target="_blank" rel="noopener nofollow" title="worldhighways">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Sur le lieu de travail :' | translate}}</p>
                <p class="text-justify">{{'Ces défis sont principalement liés à des conditions de travail dangereuses dans les domaines du travail en hauteur, du travail avec l’énergie électrique, de l’excavation, de la manutention, y compris des équipements et des outils, ainsi que des différents types de construction de chaussées.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Des exercices numériques immersifs qui peuvent être faits à plusieurs reprises pour permettre une formation plus rapide et plus efficace afin d’accélérer le développement des compétences et l’apprentissage pour se préparer aux risques potentiels sur le lieu de travail et réduire efficacement les accidents.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/motorways-workshop2.webp" type="image/webp">
                <source srcset="assets/motorways-workshop2.jpg" type="image/jpg">
                <img src="assets/motorways-workshop2.jpg" class="block-rounded abstract-formation" alt="Visual of the VR based Motorway Operations course developed by Immersive Factory" title="Motorway Operations training" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/femme_VR.webp" type="image/webp">
                <source srcset="assets/femme_VR.jpg" type="image/jpg">
                <img src="assets/femme_VR.jpg" class="block-rounded abstract-formation" alt="A woman using a VR headset to train for EHS risks" title="Immersive VR training" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Parmi la main-d’oeuvre :' | translate}}</p>
                <p class="text-justify">{{'Ces défis sont liés au manque d’aptitudes et de compétences dû à une formation inadéquate.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Plus de 30 exercices immersifs avec des formations efficaces, fondés sur des méthodes d’apprentissage immersives (par exemple, la ' | translate}} <a class="source" [routerLink]="language.navigateAccordingToLang(['/blog/134-How-does-Gamification-help-EHS-training'])" target="_blank" rel="noopener nofollow" title="How does Gamification help EHS training">{{'gamification' | translate}}</a>{{') grâce à leur co-création avec des acteurs clés du secteur qui conduisent à des travailleurs compétents.' | translate}}
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Environnement externe :' | translate}}</p>
                <p class="text-justify">{{'Ces défis sont des facteurs incontrôlables tels que le manque d’infrastructures, l’application de (nouvelles) réglementations légales, les difficultés liées à l’emplacement géographique du lieu de travail, le climat hostile (par exemple, plus de neige en raison du changement climatique). Enfin, l’aspect hygiénique suite à la crise sanitaire COVID-19, qui comprend de nouvelles mesures sanitaires liées à l’hygiène mais aussi à l’éducation, la prévention et la sécurité des employés face à la crise sanitaire mondiale. Ex : référent COVID dans les entreprises.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'La vision à long terme est de créer de nouveaux exercices permettant une formation prenant en compte les défis externes tels que les mauvaises conditions météorologiques.' | translate}}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/{{'motorways-environnement-externe' | translate}}.webp" type="image/webp">
                <source srcset="assets/{{'motorways-environnement-externe' | translate}}.png" type="image/png">
                <img src="assets/{{'motorways-environnement-externe' | translate}}.png" class="block-rounded" alt="VR training workshops increase learner memory by 4" title="VR training workshops" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.webp" type="image/webp">
                <source srcset="assets/Reporting_Moyenne_Horizontal_V2.jpg" type="image/jpg">
                <img src="assets/Reporting_Moyenne_Horizontal_V2.jpg" class="block-rounded abstract-formation mb-4" alt="Website backoffice: reporting and statistics" title="Back-office" loading="lazy">
            </picture>
            <picture>
                <source srcset="assets/campus.webp" type="image/webp">
                <source srcset="assets/campus.jpg" type="image/jpg">
                <img src="assets/campus.jpg" class="block-rounded abstract-formation" alt="Immersive Factory Virtual Campus" title="Virtual Campus" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/4-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Gestion interne :' | translate}}</p>
                <p class="text-justify">{{'Ces défis proviennent de l’intérieur de l’organisation, comme le manque d’engagement/de participation des supérieurs pendant la formation, ce qui entraînera par conséquent un manque de motivation des employés. Un autre facteur interne est le manque de formation obligatoire, qui conduit à des employés sous-formés et augmente ainsi le risque d’accidents de travail potentiels. En outre, les entreprises axées sur les coûts, les délais rigides (en particulier lorsque plusieurs entreprises différentes travaillent en collaboration sur le même lieu de travail) et le manque de supervision et de (mauvaise) communication peuvent entraîner des obstacles supplémentaires à la gestion interne.' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Des exercices gamifiés pour engager et motiver les travailleurs à tous les niveaux de direction. Possibilité de suivre les efforts et les réalisations de l’équipe pour encourager tous les employés à suivre les exercices de manière répétitive afin de maintenir un niveau élevé de compétences acquises. Les exercices sont effectués sur une plateforme numérique immersive qui permet une formation en totale autonomie et offre la possibilité de se connecter au HUB à tout moment et n’importe où, afin de réduire tous les coûts cachés qui accompagnent les journées officielles de formation à la sécurité effectuées dans un lieu spécifique.' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Choisir Immersive Factory pour votre formation de sécurité routière ?' | translate}}</span>
    </div>
    <div class="text-justify">
    	<p>{{"Immersive Factory propose aux professionnels des secteurs routiers, de la manutention et de la construction des modules de réalité virtuelle pour la formation à la sécurité sur la route, sur la manipulation d'engins roulants, et aux bons gestes pour éviter les accidents sur les chantiers." | translate}}</p>
    	<p>{{"Nos programmes de formation aident votre entreprise à maintenir la sécurité de vos employés dans les secteurs nécessitant la conduite d'engins et le déplacement de vos collaborateurs en voiture ou en camion, en assurant une sensibilisation régulière aux dangers et une baisse substantielle des incidents. Il est bénéfique d'utiliser un système d'apprentissage en ligne, une plateforme e-learning utilisant de la VR comme Immersive Learning, pour sensibiliser le personnel aux différents dangers et encourager la prévention par le biais d'une formation efficace et accessible qui engage directement la participation de vos collaborateurs." | translate }}</p>
    	<p class="mb-0">{{"La méthode de formation Immersive Factory vous aide à protéger la santé de votre personnel, à respecter les lois en vigueur tout en augmentant les capacités de vos collaborateurs en termes de gestes, comportements, reflexes et attention aux risques." | translate }}</p>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">
<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur la formation immersive ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Découvrez ses avantages dans cet article de blog :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt="Immersive learning in the US" title="Immersive learning" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>

<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" alt="{{image.name}} logo" title="{{image.name}}" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr class="my-4">


<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur de la sécurité routière' | translate}}</span>
    </div>
    <div *ngIf="listProducts" class="mt-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
</div>
<hr class="my-4">
<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Témoignage client' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez notre dernier témoignage client' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Témoignage EGIS' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/Egis_Testimonial.pdf" target="_blank" rel="noopener nofollow" title="EGIS testimonial">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>
